<template>
    <el-dialog
        title="查看详情"
        :visible.sync="dialogVisible"
        width="50%">
        <div class="box-card" v-if="Object.keys(infoData).length">
            <div class="summary_complete_bag" v-if="infoData.salesType == '2'">
                <div class="summary_complete">
                    <div
                        style="border-radius: 4px 0 0 4px;"
                        @click="complete(1)"
                        v-bind:class="{ active: type === 1 }"
                    >
                        基本信息
                    </div>
                    <div
                        style="border-radius: 0 4px 4px; 0"
                        @click="complete(2)"
                        v-bind:class="{ active: type === 2 }"
                    >
                        变体信息
                    </div>
                </div>
            </div>
            <div v-if="type == 1">
                <div class="Minister-top-top productbackground">
                    <div class="Minister-top-left product-top-color">商品图片</div>
                </div>
                <el-row class="custom-container">
                    <el-image
                        v-for="(item,index) in infoData.productImages"
                        :key="index"
                        style="width: 174px; height: 174px;"
                        :src="item.url"
                    ></el-image>
                </el-row>
                <div class="Minister-top-top informationbackground">
                    <div class="Minister-top-left information-top-color">基本信息</div>
                </div>
                <div class="custom">
                    <div class="inform flex">
                        <div class="title">商品名称：</div>
                        <div>{{ infoData.title }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">中文简称：</div>
                        <div>{{ infoData.abbreviation }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">商品编号/SKU：</div>
                        <div>{{ infoData.productCode }}</div>
                    </div>
                    <div v-if="infoData.salesType != '2'">
                        <el-row v-for="(item,index) in infoData.relatedItems" :key="index">
                            <el-col :span="10">
                                <div class="inform flex">
                                    <div class="title">店铺：</div>
                                    <div>{{ item.shopName }}</div>
                            </div>
                            </el-col>
                            <el-col :span="10">
                                <div class="inform flex">
                                    <div class="title">SKU别名：</div>
                                    <div>{{ item.productCodeAlias }}</div>
                                </div>
                            </el-col>
                        </el-row>
                    </div>
                    <div class="inform flex">
                        <div class="title">分类：</div>
                        <div>{{ infoData.categoryName }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">型号尺码：</div>
                        <div>{{ infoData.sizeModel }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">商品状态：</div>
                        <!-- <div>{{ infoData.status }}</div> -->
                        <el-radio-group v-model="infoData.status">
                            <el-radio :label="1">在售</el-radio>
                            <el-radio :label="2">停售</el-radio>
                            <el-radio :label="3">试卖</el-radio>
                            <el-radio :label="4">部分停售</el-radio>
                            <el-radio :label="5">清仓</el-radio>
                            <el-radio :label="6">部分清仓</el-radio>
                        </el-radio-group>
                    </div>
                    <div class="inform flex">
                        <div class="title">货源URL：</div>
                        <div>
                        <div
                            v-for="(item,index) in infoData.sourceUrl"
                            :key="index">
                            <!-- <div style="margin-right:20px">{{ index + 1 }}：{{ item.url }}</div> -->
                            <el-link type="primary" :href="item.url" target="_blank">{{ item.url }}</el-link>
                        </div>
                        </div>
                    </div>
                    <div class="inform flex" v-if="infoData.salesType == '1'">
                        <div class="title">库存数量：</div>
                        <div>{{ infoData.stockNum }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">商品描述：</div>
                        <div>{{ infoData.productDescription }}</div>
                    </div>
                    <div class="inform flex">
                        <div class="title">备注：</div>
                        <div>{{ infoData.remark }}</div>
                    </div>
                </div>
                <div class="Minister-top-top Ministerbackground">
                    <div class="Minister-top-left Minister-top-color">SKU归属</div>
                </div>
                <div style="margin-top:20px;">
                    <el-table ref="multipleTable" :data="infoData.itemsBelonger" style="width: 100%"  border>
                        <el-table-column label="SKU归属者" prop="roleName" align="center"></el-table-column>
                        <!-- <el-table-column label="累计业绩/元" prop="achievement"  align="center"></el-table-column> -->
                        <el-table-column label="项目提成比例" prop="percentageCommission"  align="center"></el-table-column>
                        <el-table-column label="提成开始时间" prop="startTime"  align="center"></el-table-column>
                        <el-table-column label="设置时间" prop="createTime"  align="center"></el-table-column>
                    </el-table>
                </div>
            </div>
            <div v-else>
                <el-table ref="multipleTable" :data="infoData.relatedItems" style="width: 100%"  border>
                    <el-table-column
                        label="图片"
                        align="center"
                    >
                        <template slot-scope="scope">
                             <ul
                                class="checked-img-container"
                                v-if="
                                    scope.row.productSkuImages &&
                                        scope.row.productSkuImages.length
                                "
                            >
                                <li
                                    class="img-box"
                                    @click="
                                        Selected_pictures(
                                            scope.row,
                                            scope.$index
                                        )
                                    "
                                    v-for="(item,
                                    index) in scope.row.productSkuImages.slice(
                                        0,
                                        3
                                    )"
                                    :key="index"
                                >
                                    <img
                                        style="width: 100%"
                                        :src="item.url"
                                        alt
                                    />
                                </li>
                                <li
                                    class="img-box"
                                    v-show="
                                        scope.row.productSkuImages.length > 3
                                    "
                                >
                                    ...
                                </li>
                            </ul>
                        </template>
                    </el-table-column>
                    <el-table-column label="变体标识" prop="productVariantMarker"  align="center"></el-table-column>
                    <el-table-column label="颜色" v-if="isShowColor" prop="color"  align="center"></el-table-column>
                    <el-table-column label="尺寸" v-if="isShowSize" prop="size"  align="center"></el-table-column>
                    <el-table-column label="袖长" v-if="isShowSleeve" prop="sleeve"  align="center"></el-table-column>
                    <el-table-column label="腰长" v-if="isShowWaist" prop="waist"  align="center"></el-table-column>
                    <el-table-column label="SKU" align="center" width="320">
                        <template slot-scope="scope">
                            <el-input
                                v-model="scope.row.productCode"
                                style="font-size: 12px;width:100%"
                            >
                                <template slot="prepend">
                                    <p v-if="infoData.skuPrex">{{ infoData.skuPrex }} - {{ scope.row.productVariantMarker }}</p>
                                </template>
                            </el-input>
                        </template>
                    </el-table-column>
                    <el-table-column label="SKU别名" width="400" align="center">
                        <template slot-scope="scope">
                            <el-row type="flex" align="middle" 
                                v-for="(item,index) in scope.row.aliasItems"
                                :key="index"
                                style="margin-bottom:5px"
                            >
                                <el-select v-model="item.shopName" placeholder="请选择店铺" disabled>
                                    <el-option
                                        v-for="item in ShopList"
                                        :key="item.shopId"
                                        :label="item.shopName"
                                        :value="item.shopName"
                                    ></el-option>
                                </el-select>
                                <el-input
                                    disabled
                                    v-model="item.productCodeAlias"
                                    style="font-size: 12px;width:60%;margin-right:10px"
                                    maxlength="40"
                                ></el-input>
                            </el-row>
                        </template>
                    </el-table-column>
                    <el-table-column label="成本" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.productCost }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="商品库存" align="center">
                        <template slot-scope="scope">
                            <div>{{ scope.row.stock }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="状态" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.status === 1">在售</div>
                            <div v-else-if="scope.row.status === 2">停售</div>
                            <div v-else-if="scope.row.status === 3">试卖</div>
                            <div v-else-if="scope.row.status === 4">部分停售</div>
                            <div v-else-if="scope.row.status === 5">清仓</div>
                            <div v-else>部分清仓</div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <div slot="footer">
            <el-button @click="dialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
        </div>
		<el-dialog
			title="已选图片"
			class="uploaderImgVariant"
			:visible.sync="isShowVariantImg"
			width="1000px"
            append-to-body
		>
			<div class="image-container">
				<div
					class="img-box"
					v-for="item in variantImages"
					:key="item.uid"
				>
					<img :src="item.url" />
				</div>
			</div>
			<div slot="footer" class="dialog-footer">
				<el-button size="mini" @click="isShowVariantImg = false"
					>取 消</el-button
				>
				<el-button
					size="mini"
					type="primary"
					@click="isShowVariantImg = false"
					>确 定</el-button
				>
			</div>
		</el-dialog>
    </el-dialog>
</template>
<script>
import { ajaxGet,Baseurl,ajaxPost } from '../../api/api/api'
export default {
    name: 'checkInformation',
    data() {
        return {
            dialogVisible: false,
			isShowVariantImg: false, //已选图片
			variantImages: [], //已选图片
            type: 1,
            infoData: '',
            selectRidList: [],
            ShopList: [],
            roleId: '',
            companyId: ''
        }
    },
    computed: {
		isShowColor() {
			return this.infoData.relatedItems.length && this.infoData.relatedItems[0].color
		},
		isShowSize() {
			return this.infoData.relatedItems.length && this.infoData.relatedItems[0].size
		},
		isShowSleeve() {
			return this.infoData.relatedItems.length && this.infoData.relatedItems[0].sleeve
		},
		isShowWaist() {
			return this.infoData.relatedItems.length && this.infoData.relatedItems[0].waist
		},
    },
    created() {
        this.str = JSON.parse(localStorage.getItem('role'))
        this.roleId = this.str.rid
        this.companyId = this.str.company_id
    },
    methods: {
        init(item) {
            this.type = 1
            this.dialogVisible = true
            this.editProduct(item)
            this.employeesAjax()
            this.SelectTheStore()
        },
		complete(index) {
			this.type = index
		},
		// 已选图片
		Selected_pictures(item, index, dd) {
			console.log(item, dd)
			this.isShowVariantImg = true
			this.variantImages = item.productSkuImages
			console.log(this.variantImages, 'bianti')
			// this.$emit('Variant', this.variantImages)
		},
        editProduct(id) {
            const API = Baseurl + 'shopifyProduct/get/' + id
            ajaxGet(API)
                .then((res) => {
                    if(res.data.code === 1) {
                        this.infoData = res.data.data
                        // if(this.infoData.productImages.indexOf(',') != -1) {
                            const img = this.infoData.productImages.split(',')
                            this.infoData.productImages = img.map((item) => ({
                                url: item
                            }))
                        // }
                        // if(this.infoData.productImages.indexOf(',') != -1) {
                            const source = this.infoData.sourceUrl.split(',')
                            this.infoData.sourceUrl = source.map((item) => ({
                                url: item
                            }))
                        // }
                        this.infoData.itemsBelonger.forEach(item => {
                            this.selectRidList.forEach(key => {
                                if(item.roleId === key.rid) {
                                    this.$set(item, 'roleName', key.roleName + key.userName)
                                }
                            })
                        });
                        this.infoData.relatedItems.forEach(item => {
                            this.ShopList.forEach(key => {
                                if(item.shopId === key.shopId) {
                                    this.$set(item, 'shopName', shopName)
                                }
                            })
                        });
                        this.infoData.relatedItems.forEach(item => {
                            // if(item.productSkuImages.indexOf(',') != -1) {
                                const img = item.productSkuImages.split(',')
                                item.productSkuImages = img.map((key) => ({
                                    url: key
                                }))
                            // }
                        })
                        console.log(this.infoData)
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
        },
        employeesAjax(){
            const API = Baseurl + 'roleController/selectRoleListByCompanyId'
            const paramsData = { companyId: this.companyId }

            ajaxPost(API, paramsData).then(res => {
                const { code, data } = res.data
                if (code === 200) {
                    this.selectRidList = res.data.data
                } else {
                    this.$message.error(data || '操作失败')
                }
            })
        },
        SelectTheStore() {
            var param = {
                rid: this.str.rid,
                system: this.str.system,
            };
            ajaxPost(Baseurl + "sellerController/selectMyFineShopByRid", param).then(res => {
                const { code, data } = res.data;
                if (code === 200) {
                    if (!data.length) return;
                    var sellerInfos = data;
                    var newArr = [];
                    var num = 0;
                    for (var i = 0; i < sellerInfos.length; i++) {
                        var shop = sellerInfos[i].countryMarks;
                        for (var j = 0; j < shop.length; j++) {
                            shop[j].sellerId = sellerInfos[i].sellerId;
                            shop[j].mwsAuthToken = sellerInfos[i].mwsAuthToken;
                            newArr[num] = shop[j];
                            num++;
                        }
                    }
                    this.ShopList = newArr.sort((a, b) => a.order - b.order);
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.custom-container {
    padding: 0 20px;
    margin-bottom: 40px;
    display: flex;
    align-items: center;
    .el-image{
        margin-right: 10px;
    }
}
.Minister-top-top {
    width: 100%;
    height: 30px;
    margin-bottom: 20px;
    border-radius: 3px;
    .Minister-top-left {
        border-radius: 3px 0 0 3px;
        width: 80px;
        line-height: 30px;
        float: left;
        text-align: center;
        font-size: 16px;
        color: #fff;
    }
    .Minister-top-color {
        // color: #567801;
        background: #39b54a;
    }
    .product-top-color {
        // color: #000;
        background: #f37b1d;
    }
    .information-top-color {
        // color: #026695;
        background: #0081ff;
    }
    .Minister-top-right {
        width: 80px;
        line-height: 40px;
        float: right;
        font-size: 16px;
        text-align: center;
    }
}
.informationbackground {
    background: #bfe2f3;
}
.productbackground {
    background: #fde6d2;
}
.Ministerbackground {
    background: #d7f0dbff;
}
.custom {
    padding: 0 20px;
    margin-bottom: 30px;
    .inform {
        line-height: 36px;
        &.flex {
            display: flex;
            .title {
                flex-shrink: 0;
                font-weight: bold;
                margin-right: 5px;
            }
        }
    }
}
.summary_complete_bag{
    overflow: hidden;
    .summary_complete {
        overflow: hidden;
        margin-bottom: 20px;
        // border-bottom: 1px #2B5797 solid;
        // border-bottom: 1px #eee solid;
        div {
            padding: 0 10px;
            height: 30px;
            line-height: 30px;
            border: #2c8dff 1px solid;
            text-align: center;
            // color: #2c8dff;
            float: left;
            cursor: pointer;
        }
        .active {
            background: #2c8dff;
            color: #fff;
        }
    }
}
.el-radio-group {
    // line-height: 36px;
    margin-top: 6px;
}
.checked-img-container {
	width: 100%;
	height: 36px;
	display: flex;
	align-items: flex-end;
	margin-bottom: 5px;

	.img-box {
		width: 28px;
		height: 28px;
		border-radius: 4px;
		position: relative;
		margin-right: 10px;
		line-height: 28px;

		img {
			width: 100%;
			height: 100%;
			border: 1px solid #dcdfe6;
		}

		.el-icon-circle-close {
			display: none;
			position: absolute;
			right: -7px;
			top: -7px;
			color: #999;
			font-size: 14px;
			font-weight: 700;
			cursor: pointer;
		}

		&:hover .el-icon-circle-close {
			display: block;
		}
	}
}
.image-container {
	display: flex;
	flex-wrap: wrap;

	.img-box {
		width: 178px;
		height: 178px;
		margin-right: 10px;
		margin-bottom: 10px;
		border: 1px solid #eee;
		border-radius: 6px;

		img {
			width: 100%;
			height: 100%;
		}
	}
}
</style>